import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../redux/user/actions.user';
import errorMessages from '../../../../const/errorMessages';
import errorCodes from '../../../../const/errorCodes';
import menuItems from '../../../../const/menuItems';
import GoogleButton from '../GoogleButton/GoogleButton';
import showOauthDialog from '../../../../services/mini/showOauthDialog';
import signUpLogo from '../../../../assets/images/login/icon-mail-small.svg';
import GithubButton from '../../../components/GithubButton/GithubButton';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import isValidEmail from '../../../../services/mini/isValidEmail';
import ValidationForm from '../../../forms/ValidationForm';
import LoginFormSubtitle from '../LoginFormSubtitle/LoginFormSubtitle';
import GaService from '../../../../services/GaService';
import { isAnyAuthAvailable, isGithubAuthAvailable, isGoogleAuthAvailable, isEmailAuthAvailable } from '../../../../utils/env/loginEnv';


class SignUpForm extends React.Component {
    validatePassword({ password }) {
        if (!password) {
            return 'Enter your password';
        }
        if (password && password.length < 8) {
            return errorMessages[errorCodes.passwordTooShort];
        }
        if (password.length > 0 && (password[0] === ' ' || password[password.length - 1] === ' ')) {
            return errorMessages[errorCodes.passwordIsEmpty];
        }
        return null;
    }

    validateConfirmPassword({ password, confirmedPassword }) {
        if (!confirmedPassword) {
            return 'Confirm your password';
        }
        if (password !== confirmedPassword) {
            return "Your passwords don't match";
        }
        return null;
    }

    validateEmail({ email }) {
        if (!isValidEmail(email)) {
            return 'Enter valid email address';
        }
        if (!email) {
            return 'Enter an email address';
        }
        return null;
    }

    signUp = ({ email, password }) => {
        GaService.sendSignUpEvent();
        this.props.signUp({
            email: email || this.props.email,
            password,
            invitationCode: this.props.invitationCode
        });
    }

    signUpWithGoogle = () => {
        const { invitationCode, getGoogleOauthUrl } = this.props;
        GaService.sendSignUpWGoogleEvent();
        getGoogleOauthUrl({ invitationCode }).then((authUrl) => {
            showOauthDialog(authUrl);
        });
    }

    signUpWithGitHub = () => {
        const { invitationCode, getGithubOauthUrl } = this.props;
        GaService.sendSignUpWGitHubEvent();
        getGithubOauthUrl({ invitationCode }).then((authUrl) => {
            showOauthDialog(authUrl);
        });
    }

    render() {
        const { email, disableEmail, logInInProcess, features } = this.props;
        // todo: refactor sing in/up forms because there are duplicated code
        const emailSignUpHeader = `${isGoogleAuthAvailable(features) || isGithubAuthAvailable(features) ? 'Or ' : ''}Sign Up with Email`;

        return (
            <div className="sign-up-form">
                {isGoogleAuthAvailable(features) && <GoogleButton onClickAction={this.signUpWithGoogle} title="Sign Up with Google" className="g-track-sign-up-with-google" />}
                {isGithubAuthAvailable(features) && <GithubButton onClickAction={this.signUpWithGitHub} title="Sign Up with GitHub" className="g-track-sign-up-with-github" />}
                {isEmailAuthAvailable(features) && <>
                    <LoginFormSubtitle title={emailSignUpHeader} />

                    <ValidationForm
                        enableActionBtnByDefault={true}
                        enableActionBtnAlways={true}
                        inputs={[
                            {
                                label: "Email",
                                name: "email",
                                value: email,
                                placeholder: 'Email, e.g. alan@nasa.com',
                                disabled: disableEmail,
                                autoComplete: "email",
                                tabIndex: 1,
                                applyOnEnter: true,
                                runFullValidationOnEnter: true,
                                rules: [this.validateEmail],
                                onChange: this.props.onEmailChange
                            },
                            {
                                label: "Password",
                                name: "password",
                                type: "password",
                                autoComplete: "new-password",
                                tabIndex: 2,
                                applyOnEnter: true,
                                runFullValidationOnEnter: true,
                                rules: [this.validateConfirmPassword, this.validatePassword]
                            },
                            {
                                label: "Confirm Password",
                                name: "confirmedPassword",
                                type: "password",
                                autoComplete: "new-password",
                                tabIndex: 3,
                                applyOnEnter: true,
                                runFullValidationOnEnter: true,
                                rules: [this.validateConfirmPassword]
                            }
                        ]}
                        buttons={[{
                            key: 'ok',
                            content: <React.Fragment><img src={signUpLogo} />Sign Up</React.Fragment>,
                            action: this.signUp,
                            className: `sign-up-form_btn light ${logInInProcess && 'btn-loader'} g-track-sign-up-with-email`
                        }]}
                    /></>}
                {!isAnyAuthAvailable(features) && <div className="sign-in-form_no-login">Please, contact <a href="mailto:support@alan.app"
                    target="_blank" rel="noreferrer">support</a> to specify the sign up methods</div>}

            </div>
        );
    }
}


function mapStateToProps({ config }) {
    return {
        features: config.features
    };
}

function mapDispatchToProps(dispatch) {
    return {
        signUp: (param) => dispatch(actions.signUp(param)),
        getGoogleOauthUrl: (param) => asyncDispatch(actions.getGoogleOauthUrl, dispatch, param),
        googleSignUp: (param) => asyncDispatch(actions.googleSignUp, dispatch, param),
        getGithubOauthUrl: (param) => asyncDispatch(actions.getGithubOauthUrl, dispatch, param),
        githubSignUp: (param) => asyncDispatch(actions.githubSignUp, dispatch, param),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUpForm);
